export const clone = (object: any) => {
  var cloneObj: any = {};
  for (var attribut in object) {
    if (Array.isArray(object[attribut])) {
      cloneObj[attribut] = [];
      for (let i = 0; i < object[attribut].length; i++) {
        cloneObj[attribut].push(clone(object[attribut][i]));
      }
    } else if (typeof object[attribut] === 'object') {
      if (object[attribut] instanceof Date) {
        cloneObj[attribut] = object[attribut];
      } else {
        cloneObj[attribut] = clone(object[attribut]);
      }
    } else {
      cloneObj[attribut] = object[attribut];
    }
  }
  return cloneObj;
};
